import React from 'react';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';
import { AppState } from '../../app/types';
import { GroupId } from '../../config/systemConfig';
import { getRecentMilestones } from '../../utils/activityHelpers';
import { Card } from '../ui/Card';
import { itemVariants } from '../shared/animations';
interface MilestonesSectionProps {
  state: AppState;
  selectedGroup: GroupId;
}
export function MilestonesSection({
  state,
  selectedGroup
}: MilestonesSectionProps) {
  const milestones = getRecentMilestones(state, selectedGroup);
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'level_up':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'subject_complete':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      case 'streak':
        return 'bg-orange-100 text-orange-700 border-orange-200';
      case 'first_practice':
        return 'bg-green-100 text-green-700 border-green-200';
      default:
        return 'bg-slate-100 text-slate-700 border-slate-200';
    }
  };
  return <div className="space-y-4" data-id="element-1858">
      <div className="flex items-center gap-3 px-1" data-id="element-1859">
        <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center" data-id="element-1860">
          <Trophy className="w-5 h-5 text-amber-600" data-id="element-1861" />
        </div>
        <h2 className="text-xl font-black text-slate-800" data-id="element-1862">Mijn Mijlpalen</h2>
      </div>

      {milestones.length === 0 ? <Card className="p-6 text-center bg-slate-50 border-dashed border-2 border-slate-200 rounded-2xl shadow-sm" data-id="element-1863">
          <p className="text-slate-500 font-medium" data-id="element-1864">
            Ga oefenen om je eerste mijlpaal te verdienen! 🎯
          </p>
        </Card> : <div className="flex overflow-x-auto pb-4 -mb-4 md:grid md:grid-cols-2 lg:grid-cols-3 gap-4 snap-x" data-id="element-1865">
          {milestones.map((milestone, i) => <motion.div key={`${milestone.type}-${milestone.timestamp}-${i}`} variants={itemVariants} className="min-w-[240px] snap-start" data-id="element-1866">
              <Card className={`p-4 flex items-center gap-4 border-2 rounded-2xl ${getTypeColor(milestone.type)} bg-opacity-50 shadow-sm`} data-id="element-1867">
                <div className="text-3xl bg-white w-12 h-12 rounded-full flex items-center justify-center shadow-sm" data-id="element-1868">
                  {milestone.emoji}
                </div>
                <div className="flex-1" data-id="element-1869">
                  <p className="font-bold text-sm leading-tight" data-id="element-1870">
                    {milestone.label}
                  </p>
                </div>
              </Card>
            </motion.div>)}
        </div>}
    </div>;
}